export class Recurring {
    type: string;
    startDate: string;
    repeatType: string;
    repeatBy: Number;
    repeatByDate: any;
    repeatByDays: string[];
    repeatEnds: Number;
    repeatEndsValue: any;

    endTime: string;
    meetingDay: string;
    meetingEndDate: string;
    meetingRecurrenceDate: string;
    startTime: string;

    constructor() {
        this.type = '';
        this.startDate = '';
        this.repeatType = '';
        this.repeatBy = 0;
        this.repeatByDate = '';
        this.repeatByDays = [];
        this.repeatEnds = 0;
        this.repeatEndsValue = '';
        this.endTime = '';
        this.meetingDay = '';
        this.meetingEndDate = '';
        this.meetingRecurrenceDate = '';
        this.startTime = '';
    }
}
